import React from 'react';
import { PageStyle } from '../Utils/generalStyles';
import ContractSection from '../Components/Contract';
import FooterSection from '../Components/Footer';

const contractPage = () => (
  <PageStyle>
    <ContractSection />
    <FooterSection />
  </PageStyle>
);

export default contractPage;
